import ApiService from '@/common/api.service'

import {
  UPLOAD_FILE
} from './actions.type'

import {
  SET_UPLOADED_FILE_URL,
  SET_ERROR
} from './mutations.type'

const state = {
  isLoading: false,
  fileUrl: null,
  error: null
}

const getters = {

}

const actions = {
  async [UPLOAD_FILE](context, { file, imageType }) {
    try {
      const res = await ApiService.uploadFile('api/v1/files/upload',
        [{ key: 'upload', value: file }, { key: 'imageType', value: imageType }])
      context.commit(SET_UPLOADED_FILE_URL, res.data)
      return res.data
    } catch ({ response }) {
      context.commit(SET_ERROR, response.data)
      return response.data
    }
  }
}

const mutations = {
  [SET_UPLOADED_FILE_URL](state, url) {
    state.fileUrl = url
    state.error = null
  },
  [SET_ERROR](state, error) {
    state.error = error
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
